module.exports = __webpack_public_path__ + "static/location-info5-48b1b84ef63167282545c971a10b7ad5.jpg";